import styles from './PricingTableCell.scss';

import React from 'react';

import { TransactionRate } from 'src/services/dcs/bundle';
import { BundleFeatureValue } from '../types';
import { PricingTableCellContent } from './PricingTableCellContent/PricingTableCellContent';

export interface PricingTableCellProps {
  value?: BundleFeatureValue;
  keyedInRate?: TransactionRate;
  inPersonRate?: TransactionRate;
  categoryId?: string;
  featureId?: string;
  bundleId?: string;
}

export const PricingTableCell: React.FC<PricingTableCellProps> = ({ value, keyedInRate, inPersonRate, categoryId, featureId, bundleId }) => {
  return (
    <td className={styles.cell} headers={`feature-${featureId} category-${categoryId} bundle-${bundleId}`}>
      <div className={styles.cellContent}>
        <PricingTableCellContent value={value} keyedInRate={keyedInRate} inPersonRate={inPersonRate} />
      </div>
    </td>
  );
};
